const columns= [
    {
        title: 'Name',
        dataIndex: 'name',
        sorter:true,      
    },
    {
        title: 'Email',
        dataIndex: 'email',
        sorter:true,      
    },
    {
        title: 'Mobile No.',
        dataIndex: 'phoneNo',
        sorter:true,
    },
    {
        title: 'Request Date',
        dataIndex: 'createdDate',
        sorter:true,
    },   
    {
        title: 'Approve On',
        dataIndex: 'actionDate',
        sorter:true,
    }, 
    {
        title: 'Action By',
        dataIndex: 'actionBy',
        sorter:true,
    },  
    {
        title:'Action',
        dataIndex:'action'
    }
];

export default columns;